<template>
    
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10" style="text-align: left;">建设，创造，革新</span>
        <h1>Franka机器人开发平台</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          专为Franka Research 3机器人平台开发者打造的资源中心。这里汇聚了丰富的工具链、开发库与详尽文档，助您加速开发进程。无论您是经验丰富的工程师，还是初入机器人领域的新手，都能获得实现创意所需的全方位支持。
        </span> 
      </div>  
      <div class="display-width">
        <img src="@/assets/images/resources/System Overview_June2025-1.png" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">资料</span>
      <hr class="divider">
    </div>
    <div class="c-text-column c-text-left c-font-14 px-container c-mb-60" style="position: relative;line-height: 1.5;">
      <h3 style="font-size: 28px;">入门指南</h3>
      <div class="c-mb-20">帮助您设置、理解并操作 Franka 机器人系统的重要资源。</div>
      <div>-<strong>系统镜像更新日志</strong>
          <a href="https://download.franka.de/Franka_Robotics_Update_History.pdf" target="_self" class="linkTag">&nbsp;[链接]&nbsp;</a>
        获取系统镜像版本的完整历史记录，包括新功能、改进和错误修复。</div>
      <div>-<strong>产品文档</strong>
          <a href="/#/documents" target="_self" class="linkTag">&nbsp;[链接]&nbsp;</a> 
        获取产品手册及其他支持材料，如数据表和安装快速指南。</div>

      <div>-<strong>系统概览</strong>
          <a href="https://franka.de/hubfs/System%20Overview_June2025-1.png?hsLang=en" target="_self" class="linkTag">&nbsp;[链接]&nbsp;</a>
        直观展示系统各组件如何连接及交互的可视化概览。</div>
    </div>
    <div class="c-text-column c-text-left c-font-14 px-container c-mb-60" style="position: relative;line-height: 1.5;">
      <h3 style="font-size: 28px;">FCI、libfranka、MATLAB 工具箱、ROS、ROS 2</h3>
      <div class="c-mb-20">官方库、工具箱与文档合集。收录了用于在不同平台上集成、控制和仿真 Franka 机器人的官方库、工具箱和文档。</div>
      <div>- <strong>FCI 文档</strong><a href="https://frankaemika.github.io/docs/" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a>|在这里，您可以找到 Franka 控制接口的概述、教程和安装说明。
      </div>
      <div>- <strong>libfranka</strong><a href="https://github.com/frankaemika/libfranka" class="linkTag" target="_self">&nbsp;[源代码]&nbsp;</a> 
        <a href="https://frankaemika.github.io/libfranka/0.15.0/" class="linkTag" target="_self">&nbsp;[API 文档]&nbsp;</a>|
        该库提供了与机器人交互的 C++ 接口，并可访问机器人的运动学和动力学模型。
      </div> 
      <div>- <strong>pylibfranka</strong><a href="https://github.com/frankarobotics/libfranka/tree/0.16.0/pylibfranka" class="linkTag" target="_self">&nbsp;[仓库]&nbsp;</a>| libfranka（≥ 0.16.0）的官方 Python 绑定，让您可以直接控制 Franka 机器人。包含不同控制器、夹爪操作和读取机器人状态的示例脚本。
      </div>
      <div>- <strong>ROS</strong>
        <a href="https://github.com/frankaemika/franka_ros" class="linkTag" target="_self">&nbsp;[源代码]&nbsp;</a> 
        <a href="https://wiki.ros.org/franka_ros" class="linkTag" target="_self">&nbsp;[ROS Wiki]&nbsp;</a>| 集成到 MoveIt 规划框架中，并支持多臂配置、外部夹爪和视觉功能。
      </div> 
      <div>- <strong>ROS 2 – Humble 支持</strong>
        <a href="https://github.com/frankarobotics/franka_ros2" class="linkTag" target="_self">&nbsp;[源代码]&nbsp;</a>
        <a href="https://frankarobotics.github.io/docs/doc/franka_ros2_humble/docs/index.html" class="linkTag" target="_self">&nbsp;[文档]&nbsp;</a>| libfranka 的 ROS2 集成：通过 ros2_control 实现扭矩控制，支持 MoveIt2 和夹爪集成
      </div> 
      <div>- <strong>ROS 2 – Jazzy 支持</strong>
        <a href="https://github.com/frankarobotics/franka_ros2/tree/jazzy" class="linkTag" target="_self">&nbsp;[源代码]&nbsp;</a>
        <a href="https://frankarobotics.github.io/docs/doc/franka_ros2_jazzy/docs/index.html" class="linkTag" target="_self">&nbsp;[文档]&nbsp;</a>| 对 ROS 2 Jazzy 的官方支持（自 franka_ros2 v3.0.0 起），为研究和开发工作流提供稳定可靠的基础。
      </div> 
      <div>- <strong>Franka Toolbox for MATLAB </strong> 
        <a href="https://github.com/frankarobotics/franka_toolbox_for_matlab" class="linkTag">&nbsp;[仓库]&nbsp;</a>
        <a href="https://frankarobotics.github.io/docs/franka_matlab/" class="linkTag">&nbsp;[文档]&nbsp;</a>
        <a href="https://franka.de/franka-toolbox-for-matlab" class="linkTag" target="_self">&nbsp;[网页]&nbsp;</a>
        | 现已开源并免费授权。可完全访问 Simulink 工具箱中的所有实时接口和动力学模型参数。
      </div> 
      <div class="c-font-12">*使用 Franka Toolbox for MATLAB 需要安装 The MathWorks, Inc. 的附加软件，详情请参阅文档。不同版本的 Franka Toolbox for MATLAB、libfranka 和 MATLAB® / Simulink® 之间的兼容性概览可在文档中查看。</div>
      <div>- <strong>Franka Toolbox for MATLAB 归档版本</strong>
        <a href="https://download.franka.de/franka_matlab_v3.0.0.mltbx" class="linkTag">&nbsp;[版本 3.0.0]&nbsp; </a>
        <a href="https://download.franka.de/franka_matlab_v2.0.0.mltbx" class="linkTag">&nbsp;[版本 2.0.0]&nbsp; </a>
        <a href="https://download.franka.de/franka_matlab_v1.0.0.mltbx" class="linkTag">&nbsp;[版本 1.0.0]&nbsp; </a>
        <a href="https://download.franka.de/franka_matlab_v0.3.1.tar.gz" class="linkTag">&nbsp;[版本 0.3.1]&nbsp; </a>
        <a href="https://download.franka.de/franka_matlab_v0.3.0.tar.g" class="linkTag">&nbsp;[版本 0.3.0]&nbsp; </a>
        <a href="https://download.franka.de/franka_matlab_v0.2.1.tar.gz" class="linkTag">&nbsp;[版本 0.2.1]&nbsp; </a>
        <a href="https://download.franka.de/franka_matlab_v0.2.0.tar.gz" class="linkTag">&nbsp;[版本 0.2.0]&nbsp; </a>
        <a href="https://download.franka.de/franka_matlab_v0.1.1.tar.gz" class="linkTag">&nbsp;[版本 0.1.1]&nbsp; </a>| Franka Toolbox for MATLAB 的归档版本。
      </div>  
         <div class="c-font-12">*1.0.0、2.0.0 和 3.0.0 版本需要购买许可证密钥进行激活。</div>
    </div>  
    <a id="spacemouse-anchor" data-hs-anchor="true"></a>
    <div class="c-text-column c-text-left c-font-14 px-container c-mb-60" style="position: relative;line-height: 1.5;">
      <h3 style="font-size: 28px;">官方示例与集成</h3>
      <div class="c-mb-20">官方支持的示例项目和集成方案，展示如何在实际场景中应用Franka机器人。适合学习最佳实践、加速部署，并将经过验证的解决方案适配到您自己的应用中。</div>
      
      <div>- <strong>SpaceMouse 遥操作</strong><a href="https://github.com/frankarobotics/franka_spacemouse" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        | 基于ROS 2的集成方案，使用3Dconnexion SpaceMouse对Franka FR3进行实时笛卡尔速度控制。包含夹爪控制、多臂支持和开发容器（devcontainer）配置——适合遥操作、力觉控制和教学演示。
      </div>
      <div>- <strong>GELLO 遥操作系统</strong> <a href="https://github.com/wuphilipp/gello_software/tree/main/ros2" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        | 基于ROS 2的集成方案，通过GELLO遥操作框架对FR3进行实时控制。可通过输入设备实现低延迟的关节阻抗控制和夹爪（Franka Hand及Robotiq）驱动。包含开发容器，可快速完成设置。适合人机交互（HRI）、快速原型制作和教育领域。
      </div>
      <div>- <strong>力觉遥操作</strong> <a href="https://github.com/frankarobotics/franka_ros2_teleop" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a>
        | 基于ROS 2的集成方案，使用一台FR3（主机）对另一台FR3（从机）进行实时遥操作。从机跟随主机的运动，并将接触力反馈回主机，使操作者能够实时感知受力。包含Docker和ROS 2快速启动选项及完整设置说明。适合人机协作研究、接触式操作和力觉探索。
      </div>
    </div>
    <div class="c-text-column c-text-left c-font-14 px-container c-mb-60" style="position: relative;line-height: 1.5;">
      <h3 style="font-size: 28px;">LABS</h3>
      <div class="c-mb-20">LABS——<strong>学习与行为获取套件（Learning & Acquisition of Behaviors Suite）</strong>—是一个开源、微服务驱动的机器人数据编排平台，可在统一的数据采集流水线中协调机器人、传感器和遥操作设备。</div>
      <div>- <strong>代码仓库</strong><a href="https://github.com/frankarobotics/labs" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a>
        | 仓库内提供详尽的文档，包括架构概览、部署指南、各服务专属的README以及开发说明，帮助您快速上手并扩展该平台。
      </div>
    </div>
    <div class="c-text-column c-text-left c-font-14 px-container c-mb-60" style="position: relative;line-height: 1.5;">
      <h3 style="font-size: 28px;">Desk</h3>
      <div class="c-mb-20">Desk 是一个基于浏览器的用户界面，专为创建简单应用程序而设计，非常适合快速设置机器人行为、实验配置以及人机交互演示。</div>
      
      <div>- <strong>教程 1</strong><a href="https://www.youtube.com/watch?v=TRMIA2J29MA&feature=youtu.be" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
        | 关于 Desk 及其功能的入门教程，介绍如何使用 Apps 创建任务。
      </div>
      <div>- <strong>教程 2</strong><a href="https://www.youtube.com/watch?v=hCfn0mzHLyM&feature=youtu.be" class="linkTag" target="_self">&nbsp;[链接]&nbsp;</a> 
         关于 Pilot 的教程，Pilot 是用于与 Franka Hand 和 Desk 用户界面交互的控制器。
      </div>
    </div>
    <div class="c-text-column c-text-left c-font-14 px-container c-mb-60" style="position: relative;line-height: 1.5;">
      <h3 style="font-size: 28px;">Desk API</h3>
      <div class="c-mb-20">该RESTful接口可程序化访问（几乎）所有通过Desk界面实现的功能，是将弗兰卡机器人集成至大型自动化系统的理想方案。您可通过该API突破图形界面的限制，实现对机器人的远程监控、操作及维护。</div>
      
      <div class="c-mb-10"><strong>主要功能:</strong> </div>
      <div>  - 解除制动、激活FCI或清除安全违规</div>
      <div>  - 管理系统配置（网络、用户等）</div>
      <div>  - 运行诊断并下载用户日志文件</div>
      <div class="c-mb-20">  - 与工业级编排工具无缝集成</div>
      <div class="c-mb-20">自系统镜像v5.8版本起，该API面向所有用户免费开放，仅需网络连接即可调用。</div>
      <div>- <strong>API参考文档</strong>&nbsp;[可通过Desk下拉菜单或访问＜您的机器人IP＞/deskapi获取]&nbsp;
        完整包含终端节点、参数说明、调用方法及错误响应的技术文档。
      </div>
    </div>
    <div class="c-text-column c-text-left c-font-14 px-container c-mb-60" style="position: relative;line-height: 1.5;">
      <h3 style="font-size: 28px;">RIDE（机器人集成开发环境）和 RACE</h3>
      <div class="c-mb-20">RIDE 是一款用于编写自定义 Desk 应用程序并将外部传感器及其他功能连接到系统的工具。</div>
      
      <div>- <strong>ride-cli（RIDE 命令行界面） 下载*</strong>
        <a href="https://download.franka.de/ride-cli-doc/index.html" class="linkTag" target="_self">&nbsp;[Franka  Robotics 机器人]&nbsp;</a> 
        <a href="https://download.franka.de/ride-cli-doc-v1.0.0/index.html" class="linkTag" target="_self">&nbsp;[Franka Research 3]&nbsp;</a> 
        | 通过这个基于文本的界面，您可以从命令行开发机器人应用程序。
        <div class="c-font-12">*您还没有应用程序开发功能吗？请联系  
          <router-link to="/contact" class="linkTag" >Franka Robotics 团队。</router-link> 
          </div> 
      </div>
     
      <div>- <strong>ride-cli 文档</strong>
        <a href="https://download.franka.de/ride-cli-doc/index.html" class="linkTag" target="_self">&nbsp;[Franka  Robotics 机器人]&nbsp;</a> 
        <a href="https://download.franka.de/ride-cli-doc-v1.0.0/index.html" class="linkTag" target="_self">&nbsp;[Franka Research 3]&nbsp;</a> 
        | 使用 ride-cli 开发应用程序的文档。
      </div>
      <div>- <strong>race-com</strong>
        <a href="https://download.franka.de/racecom-15.4.1.zip" class="linkTag">&nbsp;[下载]&nbsp;</a> 
        <a href="https://download.franka.de/racecom-doc-v15.4.1/index.html" class="linkTag" target="_self">&nbsp;[文档]&nbsp;</a> 
        | 使用这个 C 库开发服务，使第三方硬件和外部资源可用于您的应用程序。
      </div>
      <div>- <strong>IDE 插件</strong>
        <a href="https://marketplace.visualstudio.com/items?itemName=FrankaRobotics.ride" class="linkTag" target="_self">&nbsp;[Visual Studio Marketplace]&nbsp;</a> 
        <a href="https://packagecontrol.io/packages/ride" class="linkTag" target="_self">&nbsp;[Sublime 插件]&nbsp;</a> 
        <a href="https://github.com/frankaemika/ride-vim" class="linkTag" target="_self">&nbsp;[Vim 插件]&nbsp;</a> 
        | 您可以在此下载 Visual Studio Code 或其他 IDE 的插件，以将应用程序开发功能集成到您的 IDE 中。
      </div>
    </div>
    <div class="c-text-column c-text-left c-font-14 px-container c-mb-60" style="position: relative;line-height: 1.5;">
      <h3 style="font-size: 28px;">机器人与附件3D模型资源</h3>
      <div class="c-mb-20">Franka Robotics为其机器人系统发布官方3D模型文件。随着社区的不断壮大，散落在各个仓库和平台的非官方版本也日益增多。本页面是Franka直接维护和发布的唯一官方来源，确保您始终使用的是正确且最新的几何模型。</div>
      <div>- <strong>3D模型资源 </strong> <a href="https://www.franka.de/3d-assets?hsLang=en" class="linkTag">&nbsp;[专属网页]&nbsp;</a>
        | 从该网页下载文件。
      </div>
    </div>
 
    <div class="c-text-column c-text-left c-font-14 px-container c-mb-60" style="position: relative;line-height: 1.5;">
      <h3 style="font-size: 28px;">扩展功能</h3>
      <div class="c-mb-20">通过额外的软件和硬件模块扩展您的机器人功能。</div>
      <div>- <strong>OPC UA 文档</strong>
        <a href="https://download.franka.de/opcua-server-doc-v2.0.4/index.html" class="linkTag" target="_blank">&nbsp;[Franka  Robotics 机器人]&nbsp;</a>  
        <a href="https://download.franka.de/opcua-server-doc-v7.0.1/index.html" class="linkTag" target="_blank">&nbsp;[Franka Research 3]&nbsp;</a>
        | Franka 的开放式平台通信统一架构（OPC UA）为您的机器人启用了一系列功能。查看文档以了解更多关于其潜力和使用方式的信息。
      </div>
      <div>- <strong>Modbus</strong>
        <a href="https://download.franka.de/Modbus.pdf" class="linkTag" target="_blank">&nbsp;[文档]&nbsp;</a>   
        | 查看文档以了解更多关于 Modbus 的潜力以及其在机器人上的使用方式。
      </div>
    </div>

    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">社区贡献</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap">  
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;"> 
        <h1>领略Franka社区的卓越成就</h1> 
        <span class="c-mt-10 c-mb-5 c-text-left text-indent">
          Franka社区以其在机器人技术与人工智能领域的创新协作精神而著称。探索那些令这个社区脱颖而出的杰出贡献！
        </span> 
        <!-- <span class="c-mb-10 c-text-left ">
          立即注册，一起加入Franka社区吧！
        </span>  -->
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10"> 
          <!-- <div class="buttonSite  c-mr-20" style="width: 100px;">
            注册
          </div> -->
          <!-- <div class="buttonUndertone"  style="width: 100px;">
            登录
          </div> -->
        </div>
      </div>   
      <div class="display-width">
        <img src="@/assets/images/resources/_Frank Robotics0615_resized-1 (1).jpg" alt=""
          style="    height: auto; max-width: 100%;">
      </div>
    </div>

  </template>
  
  <script>
  // import HelloWorld from './components/HelloWorld.vue'
  
  export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
    name: 'App',
    components: {
      // HelloWorld
    },
    data(){
      return {  
        
      }
    }, 
  }
  </script>
  
  <style scoped>
  
  .display-width{
    width: calc(50% - 40px);
  }
  
@media (max-width: 1029px) {
  }
  
  /* 屏幕宽度小于 900px 时，一行展示 2 个 */
  @media (max-width: 899px) {
    .display-width{
      width: 100%
    }
  }
  
  /* 屏幕宽度小于 600px 时，一行展示 1 个 */
  @media (max-width: 599px) {
  }
  
  </style>
  <style scoped> 
  /* h2 {
    font-size: 14px;
    margin-top: 10px;
    color: #333;
  } */
  </style>
